import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "daily-sync-overlay__header col-12" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" View backlog ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Close backlog ")
const _hoisted_4 = {
  key: 0,
  class: "col-12 col-md-7 overlay-sync-container"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "col-12 col-md-5 daily-sync-overlay__backlog"
}
const _hoisted_7 = { class: "daily-sync-overlay__backlog-top" }
const _hoisted_8 = { class: "daily-sync-overlay__backlog-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_DailySyncSubmission = _resolveComponent("DailySyncSubmission")!
  const _component_DailySyncUserCard = _resolveComponent("DailySyncUserCard")!
  const _component_AppTabs = _resolveComponent("AppTabs")!
  const _component_DailySyncBacklog = _resolveComponent("DailySyncBacklog")!
  const _component_GoalsBacklog = _resolveComponent("GoalsBacklog")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    id: "daily-sync-overlay",
    navMinimized: "true",
    theme: "sync-overlay",
    onCloseModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close-modal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.syncVisible)
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              theme: "home",
              icon: "table-expand",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isBacklogActive = !_ctx.isBacklogActive))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_AppButton, {
              key: 1,
              theme: "home",
              icon: "close-slim",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isBacklogActive = !_ctx.isBacklogActive))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ModalHandlerService.close()))
        }, [
          _createVNode(_component_AppIcon, { name: "close-slim" })
        ])
      ]),
      (_ctx.isDailySyncsLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "sync-overlay-close",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ModalHandlerService.close()))
            }, [
              _createVNode(_component_AppIcon, {
                name: "close-slim",
                size: "14"
              })
            ]),
            (_ctx.dailySyncOverlayActive || _ctx.trackingState)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (!_ctx.userHasSubmittedSyncForDayBeingViewed)
                    ? (_openBlock(), _createBlock(_component_DailySyncSubmission, {
                        key: 0,
                        dayBeingViewed: _ctx.dayBeingViewed,
                        userDailySync: _ctx.usersDailySyncForDayBeingViewed
                      }, null, 8, ["dayBeingViewed", "userDailySync"]))
                    : (_openBlock(), _createBlock(_component_DailySyncUserCard, {
                        key: 1,
                        user: _ctx.user,
                        userDailySync: _ctx.usersDailySyncForDayBeingViewed
                      }, null, 8, ["user", "userDailySync"]))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.backlogVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_AppTabs, {
                spaceBetween: 0,
                tabs: [_ctx.VIEWS.BACKLOG, _ctx.VIEWS.GOALS],
                "onUserAction:click": _ctx.setView,
                elevated: ""
              }, null, 8, ["tabs", "onUserAction:click"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.view === _ctx.VIEWS.BACKLOG)
                ? (_openBlock(), _createBlock(_component_DailySyncBacklog, { key: 0 }))
                : _createCommentVNode("", true),
              (_ctx.view === _ctx.VIEWS.GOALS)
                ? (_openBlock(), _createBlock(_component_GoalsBacklog, { key: 1 }))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}